import api from "../../services/axios";

export async function validarTokenConteudos(token) {
  const resp = await api.post(
    "/credenciamento-conteudos-validar-token",
    { token },
    { skipAuth: true },
  );
  return resp.data;
}

export async function concluirEscolhaConteudos({
  token,
  conteudo1,
  conteudo2,
  empresaInteresse,
}) {
  const body = {
    token,
    empresa_interesse: empresaInteresse || "",
  };
  if (conteudo1 != null) body.conteudo1 = Number(conteudo1);
  if (conteudo2 != null) body.conteudo2 = Number(conteudo2);
  const resp = await api.post("/credenciamento-conteudos-concluir", body, {
    skipAuth: true,
  });
  return resp.data;
}

export async function gerarTokenConteudos(idUsuario) {
  const resp = await api.post("/credenciamento-conteudos-token-gerar", {
    id_usuario: Number(idUsuario),
  });
  return resp.data;
}

export async function consultarTokenConteudos(idUsuario) {
  const resp = await api.get(
    `/credenciamento-conteudos-token/${Number(idUsuario)}`,
  );
  return resp.data;
}

export async function listarPatrocinadoresMatchMeet() {
  const resp = await api.get("/credenciamento-conteudos-patrocinadores", {
    skipAuth: true,
  });
  return resp.data;
}

export async function listarConteudosAgenda() {
  const resp = await api.get("/credenciamento-conteudos-agenda", {
    skipAuth: true,
  });
  return resp.data;
}
